import { ActionTree } from 'vuex';
import { IDeleteFieldState } from './delete-field.types';
import {
  EDeleteFieldAction,
  EDeleteFieldMutation,
  state as defaultState,
} from './delete-field.constants';
import { IField } from '@lib-shared/fields/types/field';
import { RootState } from '@/store/store';
import { translate } from '@/helpers/translation.helper';
import { FieldService } from '@/api/fields/services/field.service';
import { alertNamespace, EAlertAction } from '@/alert/store/alert.constants';

export const actions: ActionTree<IDeleteFieldState, RootState> = {
  async [EDeleteFieldAction.Delete]({ dispatch }, fields: IField[]) {
    try {
      const fieldIds: string[] = fields.map((field: IField) => field.id);
      if (fieldIds.length) {
        await FieldService.deleteMultiple(fieldIds);
      }
    } catch {
      dispatch(EDeleteFieldAction.DeleteFailed, fields);
    }
  },
  [EDeleteFieldAction.DeleteFailed]({ commit, dispatch }, fields: IField[]) {
    commit(EDeleteFieldMutation.SetFailedDeletedFields, fields);
    dispatch(`${alertNamespace}/${EAlertAction.ShowDanger}`, translate('could-not-delete-field'), {
      root: true,
    });
  },
  [EDeleteFieldAction.Reset]({ commit }) {
    commit(EDeleteFieldMutation.SetState, { ...defaultState });
  },
};
